import { Controller } from "@hotwired/stimulus"
import { LogoHelper } from "~/helpers/logo_helper";

export default class extends Controller {
  static get targets() {
    return ["companyTemplate", "autoComplete", "dataCount", "values", "tagsList", "tag"]
  }

  static get values() {
    return { name: String }
  }

  connect() {
    Array.from(this.valuesTarget.selectedOptions).forEach((option) => {
      this._addTag(option.value, option.text)
    })

    this._refreshDataCount()
  }

  select(event) {
    this._addTag(event.detail.domain, event.detail.name)
    this.autoCompleteTarget.value = ""

    let option = new Option(event.detail.name, event.detail.domain, true, true)
    this.valuesTarget.options.add(option)

    this._refreshDataCount()
    this._dispatchFilterEvent()

    this.autoCompleteTarget.blur()
    $(this.autoCompleteTarget).autocomplete("hide")
  }

  submit(event) {
    const domainName = App.hostnameFromURL(event.target.value)
    let companyName = domainName

    if (App.isADomainName(domainName)) {
      // Get company name from Domain
      fetch(App.api.domainsSuggestion(domainName))
        .then(response => response.json())
        .then(response => {
          companyName = response.data[0].name

          let output = { detail: { domain: domainName, name: companyName } }
          this.select(output)
        })
    }

    return
  }

  clear() {
    Array.from(this.valuesTarget.selectedOptions).forEach(option => {
      const domain = option.value
      this.remove({ params: { domain } })
    })

    this._refreshDataCount()
    this._dispatchFilterEvent()
  }

  remove({ params: { domain } }) {
    this.tagTargets.forEach((tag) => {
      if (tag.dataset.domain === domain) {
        tag.remove()
      }
    })

    this.valuesTarget.querySelector(`option[value="${domain}"]`).remove()
    this._refreshDataCount()
    this._dispatchFilterEvent()
  }

  _addTag(domain, companyName) {
    let companyPreviewHTML = this.companyTemplateTarget.innerHTML

    companyPreviewHTML = companyPreviewHTML.replace(/%LOGO_URL%/g, LogoHelper.companyLogoUrl(domain))
    companyPreviewHTML = companyPreviewHTML.replace(/%NAME%/g, companyName)
    companyPreviewHTML = companyPreviewHTML.replace(/%DOMAIN%/g, domain)

    this.tagsListTarget.insertAdjacentHTML("beforeend", companyPreviewHTML)
  }

  // Dispatch the filter event, this can be used with other elements to apply the filters.
  _dispatchFilterEvent() {
    this.dispatch("filters", {
      detail: {
        filters: [
          { name: `${this.nameValue}`, values: this._selectedValues(this.valuesTarget) },
        ]
      }
    })
  }

  // Utility method to get all values from a select element.
  _selectedValues(selectElement) {
    return Array.from(selectElement.selectedOptions).map(option => option.value)
  }

  // Refresh the data-count attribute
  _refreshDataCount() {
    if (!this.hasDataCountTarget) {
      return
    }

    let selectedOptions = this.valuesTarget.selectedOptions.length

    if (selectedOptions > 0) {
      this.dataCountTarget.dataset.count = selectedOptions
    } else {
      delete this.dataCountTarget.dataset.count
    }
  }
}
